import Link from "@mui/material/Link";
import {Link as RouterLink} from "react-router-dom";
import {Check, X} from "react-feather";
import React from "react";

export const focalPersonColumnModel = (checkIfIncluded, onCheckedChanged, toggleSelectAll, allSelected) => [
    {
        field: 'gas', headerName: 'Receives GAS', width: 150
        , renderHeader: (params) => (
            <>
                <input onClick={(val) => toggleSelectAll()} checked={allSelected} type="checkbox"/>
                Receive GAS?
            </>
        )
        , renderCell: (params) => (
            <input onClick={(val) => onCheckedChanged(params.row.person)}
            checked={checkIfIncluded(params.row.person.id)} type="checkbox"/>
        ),
        sortable: false
    },
    {
        field: 'person.name', headerName: 'Name', width: 230,
        renderCell: (params) => (
            <Link component={RouterLink} to={'/gas/contact/' + params.row.id}>
                {params.row.person.name}
            </Link>
        )
    },
    {
        field: 'person.title', headerName: 'Title', width: 200, renderCell: (params) => (
            <>{params.row.person.title}</>
        )
    },
    {
        field: 'person.email', headerName: 'Email', width: 300, renderCell: (params) => (
            <>{params.row.person.email}</>
        )
    },
    {
        field: 'active', headerName: 'Active', width: 120, renderCell: (params) => (
            <>{params.value ? <Check color='green'/> : <X/>}</>
        )
    }

]

export const recipientColumnModel = (checkIfIncluded, onCheckedChanged, toggleSelectAll, allSelected) => [
    {
        field: 'gas', headerName: 'Receives GAS', width: 120
        , renderHeader: (params) => (
            <>
                <input onClick={(val) => toggleSelectAll()}
                       checked={allSelected} type="checkbox"/>
                Receive GAS?
            </>
        )
        , renderCell: (params) => (
            <input onClick={(val) => onCheckedChanged(params.row.contact)}
            checked={checkIfIncluded(params.row.contact.id)} type="checkbox"/>
        )
    },
    {
        field: 'person.name', headerName: 'Name', width: 230,
        renderCell: (params) => (
            <Link component={RouterLink} to={'/gas/contact/' + params.row.id}>
                {params.row.contact.name}
            </Link>
        )
    },
    {
        field: 'person.title', headerName: 'Title', width: 200, renderCell: (params) => (
            <>{params.row.contact.title}</>
        )
    },
    {
        field: 'person.email', headerName: 'Email', width: 300, renderCell: (params) => (
            <>{params.row.contact.email}</>
        )
    },
    {
        field: 'active', headerName: 'Active', width: 120, renderCell: (params) => (
            <>{params.value ? <Check/> : <X/>}</>
        )
    }
]


export const GasListColumnModel = (onPreviewClicked) => [
    {
        field: 'countryName', headerName: 'Country', width: 200,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}}  component={RouterLink} to={'/gas/account-statement/' + params.row.id } 
             >
                {params.value}
            </Link>
        )
    },
    {
        field: 'grantName', headerName: 'Grant', width: 200
    },
    {
        field: 'grantValidated', headerName: 'Grant Validated', width: 150,  type: 'boolean', renderCell: (params) => (
            <>{params.value ? <Check color="green"/> : <X color="gray"/>}</>
        )
    },
    {
        field: 'emailsValidated', headerName: 'GAS Validated', width: 150, type: 'boolean', renderCell: (params) => (
            <>{params.value ? <Check color="green"/> : <X color="gray"/>}</>
        )
    },
    {
        field: 'gasFound', headerName: 'GAS found?', width: 150, type: 'boolean', renderCell: (params) => (
            <>{params.value ? <Check color='green'/> : <X color="gray"/>}</>
        )
    },
    {
        field: 'statusName', headerName: 'Status', width: 150
    },
    {
        field: 'id', headerName: 'Action', width: 150, renderCell: (params) => (
            <>
                {
                    params.row.gasFound && params.row.emailsValidated &&
                    <Link component={RouterLink} onClick={() => onPreviewClicked(params.row)}>
                        {params.row.statusName === 'Sent' && <>Resend</>}
                        {params.row.statusName !== 'Sent' && <>Send</>}
                    </Link>
                }

            </>
        )
    }
]

